<template>
  <b-navbar type="dark" variant="dark" fixed="top">
    <b-navbar-brand to="/">Cannophy</b-navbar-brand>
    <b-button id="btnGuide" variant="light" v-b-toggle.sidebar-tutorial style="opacity:80%">{{$t('navbar.guide')}}</b-button>
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
        <!--b-nav-item to="/InterParcel" :active='$route.name =="InterParcel"'>{{$t('navbar.interParcelTitle')}}</b-nav-item>
        <b-nav-item to="/ScenTechno" :active='$route.name =="ScenTechno"'>{{$t('navbar.scenTechnoTitle')}}</b-nav-item-->
      </b-navbar-nav>
    </b-collapse>
    <LangSwitcher/>
  </b-navbar>



</template>

<script>

import LangSwitcher from './LangSwitcher'
export default {
  name: "NavbarComponent",
  components: {LangSwitcher}
};
</script>

<style scoped>


</style>
